<template>
    <h1 class="mb-2"><span class="text-blue">Profile</span> <span class="text-red">Anggota</span></h1>
    <ul class="list list--tab mb-2">
        <li @click="tabs = 'akun'" :class="tabs === 'akun' ? 'nuxt-link-active' : ''"><a>Informasi Akun</a></li>
        <li @click="tabs = 'alamat'" :class="tabs === 'alamat' ? 'nuxt-link-active' : ''"><a>Informasi Alamat</a></li>
        <li @click="tabs = 'dokumen'" :class="tabs === 'dokumen' ? 'nuxt-link-active' : ''"><a>Dokumen</a></li>
    <li @click="tabs = 'minat'" :class="tabs === 'minat' ? 'nuxt-link-active' : ''" v-if="isShowExisting"><a>Minat & Keorganisasian</a></li>
        <li @click="tabs = 'keamanan'" :class="tabs === 'keamanan' ? 'nuxt-link-active' : ''"><a>Keamanan</a></li>
    </ul>
    <template v-if="tabs === 'akun'">
        <form @submit.prevent="showModal('akun')">
            <div class="text-bold mb-1">Informasi Akun</div>
            <div class="two-grid formWrap">
                <div class="left">
                    <label for="name">Nama Lengkap</label>
                    <input type="text" :disabled="!!ktpValid" name="name" v-model="nama_lengkap" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Nama lengkap harus di isi')" minlength="2" maxlength="50">
                    <label for="noAnggota">Nomor Anggota</label>
                    <input disabled type="text" name="noAnggota" v-model="no_anggota">
                    <label for="nik">NIK</label>
                    <input type="text" :disabled="!!ktpValid" name="nik" v-model="nik" required minlength="16" maxlength="16" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('nik ktp harus 16 digit')" @keypress="isInputNumber($event)">
                    <div class="two-grid">
                        <div>
                            <label for="tmpLahir">Tempat Lahir</label>
                            <input type="text" name="tmpLahir" :disabled="!!ktpValid" v-model="tempat_lahir" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Tempat Lahir harus di isi')" required minlength="2" maxlength="90">
                        </div>
                        <div>
                            <label for="tglLahir">Tanggal Lahir</label>
                            <input type="date" name="tglLahir" :disabled="!!ktpValid" v-model="tanggal_lahir" oninput="this.setCustomValidity('')"  required @change="validateBod($event)">
                        </div>
                    </div>
                    <label for="email">Email</label>
                    <input type="text" name="email" v-model="email" pattern='^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$' @invalid="invalidEmail($event)"  oninput="setCustomValidity('')">
                    <label for="kelamin">Jenis Kelamin</label>
                    <select name="kelamin" v-model="jenis_kelamin" required :disabled="!!ktpValid">
                        <option value="L">Laki - laki</option>
                        <option value="P">Perempuan</option>
                    </select>
                </div>
                <div class="right">
                    <label for="status">Status Perkawinan</label>
                    <select name="status" v-model="status_id" required :disabled="!!ktpValid">
                        <option v-for="item in statusList" :key="item.status_id" :value="item.status_id">{{item.status_name}}</option>
                    </select>
                    <label for="pekerjaan">Pekerjaan</label>
                    <select name="pekerjaan" v-model="job_id" required :disabled="!!ktpValid">
                        <option v-for="item in jobList" :key="item.job_id" :value="item.job_id">{{item.job_name}}</option>
                    </select>
                    <label for="referensi">Referensi</label>
                    <input disabled type="text" name="referensi" v-model="reference_name">

                    <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Informasi Akun</button>
                </div>
            </div>
        </form>
    </template>
    <template v-if="tabs === 'alamat'">
        <form @submit.prevent="showModal('alamat')">
            <div class="two-grid formWrap">
                <div class="left">
                    <div class="text-bold mb-3">Alamat Identitas</div>
                    <label for="provinsi">Provinsi</label>
                    <select name="provinsi" v-model="prov_id" @change="changeList($event, 'prov')" required :disabled="!!ktpValid">
                        <option value="" disabled selected hidden>Pilih Provinsi Sesuai KTP</option>
                        <option v-for="item in provinceList" :key="item.prov_id" :value="item.prov_id">{{item.prov_name}}</option>
                    </select>
                    <label for="kota">Kabupaten / Kota</label>
                    <select name="kota" v-model="kab_id" @change="changeList($event, 'kabupaten')" required :disabled="!!ktpValid">
                        <option value="" disabled selected hidden>Pilih Kabupaten/Kota Sesuai KTP</option>
                        <option v-for="item in kabList" :key="item.kab_id" :value="item.kab_id">{{item.kab_name}}</option>
                    </select>
                    <label for="kec">Kecamatan</label>
                    <select name="kec" v-model="kec_id" @change="changeList($event, 'kecamatan')" required :disabled="!!ktpValid">
                        <option value="" disabled selected hidden>Pilih Kecamatan Sesuai KTP</option>
                        <option v-for="item in kecList" :key="item.kec_id" :value="item.kec_id">{{item.kec_name}}</option>
                    </select>
                    <label for="kel">Kelurahan</label>
                    <select name="kel" v-model="kel_id" @change="changeList($event, 'kelurahan')" required :disabled="!!ktpValid">
                        <option value="" disabled selected hidden>Pilih Kelurahan Sesuai KTP</option>
                        <option v-for="item in kelList" :key="item.kel_id" :value="item.kel_id">{{item.kel_name}}</option>
                    </select>
                    <div class="two-grid" v-if="isShowExisting">
                        <div>
                            <label for="rt">RT</label>
                            <input type="text" name="rt" v-model="rt" required>
                        </div>
                        <div>
                            <label for="rw">RW</label>
                            <input type="text" name="rw" v-model="rw" required>
                        </div>
                    </div>
                    <label for="address">Alamat Lengkap</label>
                    <textarea name="address" :disabled="!!ktpValid" rows="8" v-model="alamat_ktp" required oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Alamat lengkap harus di isi')"></textarea>
                </div>
                <div class="right">
                    <div class="text-bold mb-1">Alamat Domisili</div>
                    <div class="flex switch-group mb-1">
                            <div class="text-dim text-bold">Alamat Domisili Sesuai KTP</div>
                            <label class="switch">
                                <input type="checkbox" v-model="same_address_domisili" >
                                <span class="slider round"></span>
                            </label>
                    </div>
                    <div class="two-grid">
                        <div>
                            <label for="loct">Lokasi Tinggal</label>
                            <select name="loct" v-model="lokasiTinggal" disabled required>
                                <option value="in">Dalam Negeri</option>
                                <option value="out">Luar Negeri</option>
                            </select>
                        </div>
                        <div>
                            <label for="negara">Negara</label>
                            <input :disabled="lokasiTinggal === 'in'" type="text" name="negara" v-model="negara_domisili">
                        </div>
                    </div>
                    <label for="provinsi">Provinsi</label>
                    <select :disabled="same_address_domisili" name="provinsi" v-model="prov_id_domisili" @input="changeList($event, 'prov', true)" required>
                        <option value="" disabled selected hidden>Pilih Provinsi Tempat Tinggal</option>
                        <option v-for="item in provinceList" :key="item.prov_id" :value="item.prov_id">{{item.prov_name}}</option>
                    </select>
                    <label for="kota">Kabupaten / Kota</label>
                    <select :disabled="same_address_domisili" name="kota" v-model="kab_id_domisili" @input="changeList($event, 'kabupaten', true)" required>
                        <option value="" disabled selected hidden>Pilih Kabupaten/Kota Tempat Tinggal</option>
                        <option v-for="item in kabListDomisili" :key="item.kab_id" :value="item.kab_id">{{item.kab_name}}</option>
                    </select>
                    <label for="kec">Kecamatan</label>
                    <select :disabled="same_address_domisili" name="kec" v-model="kec_id_domisili" @input="changeList($event, 'kecamatan', true)" required>
                        <option value="" disabled selected hidden>Pilih Kecamatan Tempat Tinggal</option>
                        <option v-for="item in kecListDomisili" :key="item.kec_id" :value="item.kec_id">{{item.kec_name}}</option>
                    </select>
                    <label for="kel">Kelurahan</label>
                    <select :disabled="same_address_domisili" name="kel" v-model="kel_id_domisili" @input="changeList($event, 'kelurahan', true)" required>
                        <option value="" disabled selected hidden>Pilih Kelurahan Tempat Tinggal</option>
                        <option v-for="item in kelListDomisili" :key="item.kel_id" :value="item.kel_id">{{item.kel_name}}</option>
                    </select>
                    <div class="two-grid" v-if="isShowExisting">
                        <div>
                            <label for="rt">RT</label>
                            <input v-numberonly :disabled="same_address_domisili" type="text" name="rt" v-model="rt_domisili" required>
                        </div>
                        <div>
                            <label for="rw">RW</label>
                            <input :disabled="same_address_domisili" type="text" name="rw" v-model="rw_domisili" required>
                        </div>
                    </div>
                    <label for="address">Alamat Lengkap</label>
                    <textarea :disabled="same_address_domisili" name="address" rows="3" v-model="alamat_domisili" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Alamat lengkap harus di isi')" required></textarea>
                    <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Informasi Alamat</button>
                </div>
            </div>
        </form>
    </template>
    <template v-if="tabs === 'minat'">
      <form @submit.prevent="showModal('akun')">
      <div class="twp-grid formWrap minat">
        <div class="left">
          <h3 class="text-bold text-blue">Struktur Organisasi</h3>
          <p class="mb-1">Tertarik untuk terlibat dalam struktur</p>
          <StrukturLevel :options="structures" :value="structureId" @input="structureId = $event"/>
          <div class="divider" />
          <h3 class="text-bold text-blue">Isu Strategis</h3>
          <p class="mb-1">Tertarik untuk mengerti isu strategis, pilih topik minimal 2 isu strategis</p>
          <IssuesSelector :options="issues" :value="selectedIssues" @input="selectedIssues = $event" />
        </div>
        <button class="btn-outline blue btn-profil rounded mt-2 mb-3 mr-8">Perbaharui Dokumen</button>
      </div>
      </form>
    </template>
    <template v-if="tabs === 'dokumen'">
        <form @submit.prevent="showModal('dokumen')">
            <div class="two-grid formWrap">
                <div class="left">
                    <div class="text-bold mb-1">Identitas Diri</div>
                    <img :src="ktpPicHolder" class="mb-1 image-holder" alt="test">
                    <label for="ktp">KTP</label>
                    <div class="icon-input">
                        <input disabled type="text" name="ktp" v-model="fileName">
                        <div>
                            <img @click="getKtp" class="cursor-pointer" src="@/assets/images/icon-download.svg" alt="">
                        </div>
                    </div>
                    <label for="newKtp">Unggah KTP Baru</label>
                    <div class="icon-input">
                        <input type="text" name="newKtp" v-model="newFileName" @keydown="(evt) => {evt.preventDefault()}">
                        <div class="cursor-pointer" @click="chooseFiles('fileUpload')">
                            <img src="@/assets/images/icon-upload.svg" alt="">
                        </div>
                    </div>
                    <!-- <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Identitas Diri</button> -->
                    <input id="fileUpload" style="display: none" type="file" accept="image/png, image/jpg, image/jpeg, image/webp" @change="uploadedImage($event, 'ktp')">
                </div>
                <div class="right">
                    <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Dokumen</button>
                    <input id="fileUploadProfile" style="display: none" type="file" accept="image/png, image/jpg, image/jpeg, image/webp" @change="uploadedImage($event, 'profile')">
                </div>
            </div>
        </form>
    </template>
    <template v-if="tabs === 'keamanan'">
            <div class="two-grid formWrap">
                <div class="left">
                    <form @submit.prevent="showModal('keamanan')">
                        <div class="text-bold mb-1">Ubah Kata Sandi</div>
                        <label for="old">Kata Sandi Anda</label>
                        <div class="password-group mb-1">
                            <input required oninput="this.setCustomValidity('')" class="password-field" oninvalid="this.setCustomValidity('Kata sandi harus di isi')" :type="showPass ? 'text' : 'password'" name="old" v-model="oldPassword">
                            <i class="eye-icon" :class="`far ${showPass? 'fa-eye-slash' : 'fa-eye'}`" @click="showPass ? showPass = false : showPass = true"></i>
                        </div>
                        <label for="new">Kata Sandi Baru Anda</label>
                        <div class="password-group">
                            <input minlength="6" maxlength="32" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kata sandi harus di isi')" required :type="showPass ? 'text' : 'password'" name="new" v-model="newPassword">
                            <i class="eye-icon" :class="`far ${showPass? 'fa-eye-slash' : 'fa-eye'}`" @click="showPass ? showPass = false : showPass = true"></i>
                        </div>
                        <small v-if="(newPassword === oldPassword) && oldPassword.length !== 0" style="color: red; margin-top: -90px;">Kata sandi baru tidak boleh sama dengan kata sandi lama</small><br>
                        <label for="confirm">Ulangi Kata Sandi Baru Anda</label>
                        <div class="password-group">
                            <input oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Kata sandi harus di isi')" required :type="showPass ? 'text' : 'password'" name="confirm" v-model="confirmPassword">
                            <i class="eye-icon" :class="`far ${showPass? 'fa-eye-slash' : 'fa-eye'}`" @click="showPass ? showPass = false : showPass = true"></i>
                        </div>
                        <small v-if="(newPassword !== confirmPassword) && confirmPassword.length !== 0" style="color: red; margin-top: -20px;">Kata sandi tidak sama</small>
                        <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Kata Sandi</button>
                    </form>
                </div>
                <div class="right">
                    <form @submit.prevent="showModalOtp()">
                        <div class="text-bold mb-1">Ubah Nomor Telepon</div>
                        <label for="hpOld">Nomor Telepon Anda</label>
                        <input disabled v-model="number" type="text" name="hpOld">
                        <label for="hpNew">Nomor Telepon Baru</label>
                        <input ref="newnumber" minlength="10" maxlength="16" oninput="this.setCustomValidity('')" oninvalid="this.setCustomValidity('Nomor telepon harus di isi')" required pattern="\d*" type="number" v-model="newNumber" name="hpNew">
                        <label for="new">Kata Sandi</label>
                        <div class="password-group">
                            <input maxlength="32" :type="showPass1 ? 'text' : 'password'" oninput="this.setCustomValidity('')" required oninvalid="this.setCustomValidity('Kata sandi harus di isi')" v-model="verifyPassword" ref="verifyPassword">
                            <i class="eye-icon" :class="`far ${showPass1? 'fa-eye-slash' : 'fa-eye'}`" @click="showPass1 ? showPass1 = false : showPass1 = true"></i>
                        </div>
                        <button class="btn-outline blue btn-profil rounded mt-2 mb-3">Perbaharui Nomor Telepon</button>
                    </form>
                </div>
            </div>
    </template>
    <div class="modal">
            <div :class="`overlay-wrap modal ${popUp? 'active' : ''}`">
                    <div class="close-overlay" @click="popUp = false"></div>
                    <div class="popup">
                        <div class="body text-center mb-3">
                            <template v-if="alert === 'confirm'">
                                <p class="ask">Apakah anda yakin untuk memperbaharui data Anda ?</p>
                                <p class="warning">Mohon periksa ulang perubahan yang anda lakukan, data hanya dapat diubah <span>2 kali</span> pada menu <span>{{convertTitle()}}</span>.</p>
                            </template>

                            <p v-else-if="alert === 'warning'">Maaf, Anda tidak bisa mengubah data lebih dari 2 kali. Silahkan lakukan perubahan data <span>{{convertTitle()}}</span> secara manual lewat DPP Partai terdekat.</p>
                            <p v-else-if="alert === 'error'">{{ responseErrorMsg }}</p>
                        </div>
                        <div class="footer">
                            <template v-if="alert === 'confirm'">
                                <button class="btn-fill blue yes" @click="updateData">Ya, Perbaharui</button>
                                <button class="btn-outline black no" @click="popUp = false">Batal</button>
                            </template>
                            <button v-else-if="alert === 'warning'" class="btn-fill blue yes" @click="popUp = false">Ok</button>
                            <button v-else-if="alert === 'error'" class="btn-fill blue yes" @click="popUp = false">Ok</button>
                        </div>
                    </div>
            </div>
    </div>
    <!-- <div class="flex justify-content-between">
        <div class="akun">
            <div class="text-bold mb-2">Informasi Akun</div>
            <label for="name">Nama Lengkap</label>
            <input type="text" name="name" placeholder="masukan" value=" - " v-if="profile == null">
            <input type="text" name="name" disabled v-model="profile.nama_lengkap" v-else>
            <label for="no">Nomor Telepon</label>
            <input type="text" disabled v-model="number">
        </div>
        <div class="sandi">
            <div class="text-bold mb-2">Ubah Kata Sandi</div>
            <form action="">
                <label for="sandi">Kata Sandi Anda</label>
                <input type="password" name="sandi" placeholder="Masukkan kata sandi Anda">
                <label for="newsandi">Kata Sandi baru Anda</label>
                <input type="password" name="newsandi" placeholder="Masukkan kata sandi baru Anda">
                <label for="renewsandi">Ulangi Kata Sandi baru Anda</label>
                <input type="password" name="renewsandi" placeholder="Ulangi kata sandi baru Anda">
                <button class="btn-outline blue rounded mt-3">Perbarui Kata Sandi</button>
            </form>
        </div>
    </div> -->
    <VerifikasiPopUp @onsuccessotp="onSuccessOtp()" :password="verifyPassword" :phoneNumber="newNumber" v-if="showOtpModal" />
</template>

<script>
import axios from 'axios'
import VerifikasiPopUp from '@/components/VerifikasiPopUp'
import StrukturLevel from '@/components/StrukturLevel.vue'
import IssuesSelector from '@/components/IssuesSelector.vue'

export default {
  components: {
    VerifikasiPopUp,
    StrukturLevel,
    IssuesSelector
  },
  data () {
    return {
      isShowExisting: false,
      profile: null,
      number: '',
      tempNik: '',

      tabs: 'akun',
      type: '',
      popUp: false,
      alert: 'confirm',

      nama_lengkap: '',
      no_anggota: '',
      nik: '',
      tempat_lahir: '',
      tanggal_lahir: null,
      email: '',
      jenis_kelamin: '',
      status_id: '',
      job_id: '',
      pendidikan_id: '',
      agama_id: '',
      reference_name: '',

      agamaList: [],
      pendidikanList: [],
      jobList: [],
      statusList: [],

      alamat_ktp: '',
      rt: '',
      rw: '',
      prov_id: '',
      kab_id: '',
      kec_id: '',
      kel_id: '',
      same_address_domisili: false,
      prov_id_domisili: '',
      kab_id_domisili: '',
      kec_id_domisili: '',
      kel_id_domisili: '',
      alamat_domisili: '',
      rt_domisili: '',
      rw_domisili: '',
      negara_domisili: '',
      issues: [],
      selectedIssues: [],
      structures: [],
      structureId: '',

      lokasiTinggal: 'in',

      provinceList: [],
      kabList: [],
      kecList: [],
      kelList: [],
      kabListDomisili: [],
      kecListDomisili: [],
      kelListDomisili: [],

      fileName: '',
      fileNameProfile: '',
      newFileName: '',
      newFileNameProfile: '',
      foto_ktp: null,

      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      newNumber: '',
      verifyPassword: '',
      responseErrorMsg: '',
      showOtpModal: false,
      showPass: false,
      showPass1: false,

      ktpPicHolder: '',
      profilePicHolder: '',
      ktpValid: null
    }
  },
  methods: {
    showModal (type) {
      this.alert = 'confirm'
      this.popUp = true
      this.type = type
    },
    showModalOtp () {
      if (!this.newNumber && this.newNumber.length <= 6) {
        this.$refs.newnumber.focus()
        return
      }
      if (!this.verifyPassword) {
        this.$refs.verifyPassword.focus()
        return
      }
      this.showOtpModal = true
    },
    onSuccessOtp () {
      // alert('otp success')
      this.number = this.$cookie.getCookie('number')
      this.showOtpModal = false
      this.newNumber = ''
      this.verifyPassword = ''
    },
    convertTitle () {
      let title = ''
      if (this.type === 'akun') title = 'Informasi Akun'
      if (this.type === 'alamat') title = 'Informasi Alamat'
      if (this.type === 'dokumen') title = 'Dokumen'
      if (this.type === 'keamanan') title = 'Keamanan'

      return title
    },
    async updateData () {
      this.popUp = false
      const data = new FormData()
      let type = ''
      if (this.type === 'akun') {
        type = 'account'
        data.append('nama_lengkap', this.nama_lengkap)
        if (this.tempNik !== this.nik) {
          data.append('nik', this.nik)
        }
        data.append('tempat_lahir', this.tempat_lahir)
        data.append('tanggal_lahir', this.tanggal_lahir)
        data.append('email', this.email)
        data.append('jenis_kelamin', this.jenis_kelamin)
        data.append('status_id', this.status_id)
        data.append('job_id', this.job_id)
        data.append('pendidikan_id', this.pendidikan_id)
        data.append('agama_id', this.agama_id)
        this.selectedIssues?.forEach(el => {
          data.append('issues_id', el)
        })
        data.append('category_id', this.structureId)
      } else if (this.type === 'alamat') {
        type = 'address'
        data.append('alamat_ktp', `${this.alamat_ktp} RT. ${this.rt} RW. ${this.rw}`)
        data.append('prov_id', this.prov_id)
        data.append('kab_id', this.kab_id)
        data.append('kec_id', this.kec_id)
        data.append('kel_id', this.kel_id)
        data.append('same_address_domisili', this.same_address_domisili)
        data.append('prov_id_domisili', this.prov_id_domisili)
        data.append('kab_id_domisili', this.kab_id_domisili)
        data.append('kec_id_domisili', this.kec_id_domisili)
        data.append('kel_id_domisili', this.kel_id_domisili)
        data.append('alamat_domisili', `${this.alamat_domisili} RT. ${this.rt_domisili} RW. ${this.rw_domisili}`)
        data.append('negara_domisili', this.negara_domisili)

      } else if (this.type === 'dokumen') {
        type = 'document'
        if (this.foto_ktp) {
          data.append('foto_ktp', this.foto_ktp)
        }
      } else if (this.type === 'keamanan') {
        data.append('oldpassword', this.oldPassword)
        data.append('newpassword', this.newPassword)
      } else {
        data.append('newmobilenumberr')
      }
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${this.$cookie.getCookie('token')}`
          }
        }
        const update = this.type === 'keamanan' ? await axios.post('auth/edit/cp', data, config) : await axios.patch(`member/member/${type}`, data)
        if (this.type === 'dokumen') {
          this.newFileName = ''
          this.foto_ktp = null
        }
        if (update.data.code === 200) {
          this.alertNormal(update.data.data)
          this.getProfile()
          this.getPicture()
        }
      } catch (err) {
        if (this.type === 'dokumen') {
          this.newFileName = ''
          this.foto_ktp = null
        }
        if (this.type === 'keamanan') {
          this.oldPassword = ''
          this.newPassword = ''
          this.confirmPassword = ''
          this.verifyPassword = ''
        }
        if (err.response) {
          if (err.response.data.code === 4001) {
            return this.alertFailed(err.response.data.internal_message || err.response.data.user_message?.id)
          }
          if (this.type !== 'keamanan') {
            this.alertFailed(err.response.data.internal_message || err.response.data.user_message?.id || err.message || err)
          } else {
            this.alertFailed(err.response.data.user_message?.id || err.response.data.internal_message || err.message || err)
          }
        }
      }
    },
    async getProfile () {
      try {
        const dataProfil = await axios.get('member/member')
        const data = dataProfil.data

        this.nama_lengkap = data.nama_lengkap
        this.no_anggota = data.member_no.String
        this.nik = data.nik
        this.tempNik = data.nik
        this.tempat_lahir = data.tempat_lahir
        this.tanggal_lahir = data.tanggal_lahir
        this.email = data.email
        this.jenis_kelamin = data.jenis_kelamin
        this.status_id = data.status_id
        this.job_id = data.job_id
        this.pendidikan_id = data.pendidikan_id
        this.agama_id = data.agama_id
        this.reference_name = data.reference_name

        // this.alamat_ktp = data.alamat_ktp.split('RT.')[0].trim()
        // this.rt = data.alamat_ktp.split('RT. ')[1].split(' ')[0]
        // this.rw = data.alamat_ktp.split('RW. ')[1]
        this.prov_id = data.prov_id
        this.kab_id = data.kab_id
        this.kec_id = data.kec_id
        this.kel_id = data.kel_id
        this.same_address_domisili = data.same_address_domisili
        this.prov_id_domisili = data.prov_id_domisili.Int32
        this.kab_id_domisili = data.kab_id_domisili.Int32
        this.kec_id_domisili = data.kec_id_domisili.Int32
        this.kel_id_domisili = data.kel_id_domisili.Int32
        this.alamat_ktp = data.alamat_ktp
        this.alamat_domisili = data.alamat_domisili
        // this.rt_domisili = data.alamat_domisili.String.includes('RT') ? data.alamat_domisili.String.split('RT. ')[1].split(' ')[0] : '-'
        // this.rw_domisili = data.alamat_domisili.String.includes('RW') ? data.alamat_domisili.String.split('RW.')[1] : '-'
        // this.negara_domisili = !data.same_address_domisili? data.negara_domisili.String : 'Indonesia'
        this.negara_domisili = 'Indonesia'

        // this.lokasiTinggal = data.same_address_domisili? 'in' : data.negara_domisili.String.includes('indonesia') ? 'in' : 'out'

        this.fileName = `ktp-${data.member_no.String}`
        this.fileNameProfile = `profile-${data.member_no.String}`
        this.ktpValid = data.is_valid_ktp
      } catch (err) {
        this.logger(err)
      }
    },
    async getPicture () {
      try {
        const res = await axios.get('member/member/ktp', {
          headers: {
            'content-type': 'image/png',
            accept: 'image/png'
          },
          responseType: 'blob',
          params: {
            r: Math.floor(Math.random() * (100 - 0 + 1) + 0),
            r2: Math.floor(Math.random() * (100000 - 0 + 1) + 0)
          }
        })
        const urlCreator = window.URL || window.webkitURL
        this.ktpPicHolder = urlCreator.createObjectURL(res.data)
      } catch (err) {
        this.logger(err)
      }
      try {
        const res = await axios.get('member/member/photoprofile', {
          headers: {
            'content-type': 'image/png',
            accept: 'image/png'
          },
          responseType: 'blob',
          params: {
            r: Math.floor(Math.random() * (100 - 0 + 1) + 0),
            r2: Math.floor(Math.random() * (100000 - 0 + 1) + 0)
          }
        })
        const urlCreator = window.URL || window.webkitURL
        this.profilePicHolder = urlCreator.createObjectURL(res.data)
      } catch (err) {
        this.logger(err)
        this.fileNameProfile = ''
      }
    },
    async getMasterStructure() {
      try {
        const list = await axios.get('structure/category-master')
        this.structures = list?.data?.data
      } catch (error) {
        this.logger(error)
      }
    },
    async getMasterIssues() {
      try {
        const issues = await axios.get('member/issues-master')
        this.issues = issues?.data
      } catch (error) {
        this.logger(error)
      }
    },
    async getKtp () {
      const getRandomNumberBetween = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min)
      }
      try {
        const ktp = await axios.get(`member/member/ktp?r=${getRandomNumberBetween(0, 100)}&r2=${getRandomNumberBetween(0, 10000)}`, { responseType: 'blob' })

        const url = window.URL.createObjectURL(ktp.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.fileName)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.alertFailed(err.message)
      }
    },
    async getPhotoProfile () {
      // eslint-disable-next-line no-unused-vars
      const getRandomNumberBetween = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min)
      }
      try {
        // const ktp = await axios.get('member/member/photoprofile?', { responseType: 'blob' })
        const ktp = await axios.get(`member/member/photoprofile?r=${getRandomNumberBetween(0, 100)}&r2=${getRandomNumberBetween(0, 100000)}`, { responseType: 'blob' })

        const url = window.URL.createObjectURL(ktp.data)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', this.newFileName)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        this.alertFailed(err.message)
      }
    },
    chooseFiles (id) {
      document.getElementById(id).click()
    },
    uploadedImage (e, typeFile) {
      const [file] = e.target.files
      const type = file.type

      if (!type.match('image/png') && !type.match('image/jpg') && !type.match('image/jpeg') && !type.match('image/webp')) {
        this.alertFailed('Tipe file tidak diterima.')
        return
      }
      if (typeFile === 'ktp') {
        this.newFileName = file.name
        this.foto_ktp = file
      } else {
        this.newFileNameProfile = file.name
        this.foto_profile = file
      }
    },
    uploadedImageProfile (e) {
      const [file] = e.target.files
      const type = file.type

      if (!type.match('image/png') && !type.match('image/jpg') && !type.match('image/jpeg') && !type.match('image/webp')) {
        this.alertFailed('Tipe file tidak diterima.')
        return
      }

      this.newFileNameProfile = file.name
      this.foto_profile = file
    },
    async changeList (e, type, domisili = false) {
      const id = e.target.value
      if (type === 'prov') {
        if (!domisili) {
          this.kab_id = ''
          this.kec_id = ''
          this.kel_id = ''
        } else {
          this.kab_id_domisili = ''
          this.kec_id_domisili = ''
          this.kel_id_domisili = ''
        }
        this.getKabupaten(id, domisili)
      } else if (type === 'kabupaten') {
        if (!domisili) {
          this.kec_id = ''
          this.kel_id = ''
        } else {
          this.kec_id_domisili = ''
          this.kel_id_domisili = ''
        }
        this.getKecamatan(id, domisili)
      } else if (type === 'kecamatan') {
        if (!domisili) {
          this.kel_id = ''
        } else {
          this.kel_id_domisili = ''
        }
        this.getKelurahan(id, domisili)
      }
    },
    async getProv () {
      try {
        const provList = await axios.get('member/listprovinsi')
        this.provinceList = provList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getKabupaten (id, domisili = false) {
      try {
        const kabList = await axios.get(`member/listkabupatenkota?prov_id=${id}`)
        if (!domisili) this.kabList = kabList.data
        if (domisili) this.kabListDomisili = kabList.data
        if (this.same_address_domisili) this.kabListDomisili = kabList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getKecamatan (i, domisili = false) {
      try {
        const kecList = await axios.get(`member/listkecamatan?kab_id=${i}`)
        if (!domisili) this.kecList = kecList.data
        if (domisili) this.kecListDomisili = kecList.data
        if (this.same_address_domisili) this.kecListDomisili = kecList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getKelurahan (i, domisili = false) {
      try {
        const kelList = await axios.get(`member/listkelurahandesa?kec_id=${i}`)
        if (!domisili) this.kelList = kelList.data
        if (domisili) this.kelListDomisili = kelList.data
        if (this.same_address_domisili) this.kelListDomisili = kelList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getAgama () {
      try {
        const agamaList = await axios.get('member/listagama')
        this.agamaList = agamaList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getPendidikan () {
      try {
        const pendidikanList = await axios.get('member/listpendidikan')
        this.pendidikanList = pendidikanList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getJob () {
      try {
        const jobList = await axios.get('member/listjob')
        this.jobList = jobList.data
      } catch (err) {
        this.logger(err)
      }
    },
    async getStatus () {
      try {
        const statusList = await axios.get('member/liststatus')
        this.statusList = statusList.data
      } catch (err) {
        this.logger(err)
      }
    },
    isInputNumber (evt) {
      const ch = String.fromCharCode(evt.which)
      if (!(/[0-9]/.test(ch))) {
        evt.preventDefault()
      }
    },
    pasteNumber (event) {
      const value = event.clipboardData.getData('Text')
      if (value.match(/[^\d]/)) {
        event.preventDefault()
      } else {
        this.$emit('update:nik', value)
      }
    },
    validateBod (e) {
      const birtDate = new Date(this.tanggal_lahir)
      const diffMs = Date.now() - birtDate.getTime()
      const ageDt = new Date(diffMs)
      const diff = Math.abs(ageDt.getUTCFullYear() - 1970)
      if (!this.tanggal_lahir) {
        e.target.setCustomValidity('Tanggal lahir wajib diisi')
      }
      if (diff < 17) {
        e.target.setCustomValidity('Umur harus di atas 17 tahun')
      }
    },
    invalidEmail (e) {
      if (!this.email) e.target.setCustomValidity('Email harus di isi')
      else e.target.setCustomValidity('Format email tidak valid')
    }
  },
  async mounted () {
    document.title = 'Dashboard - Profile'
    if (this.$route.query && this.$route.query.ref === 'updateprofil') {
      this.tabs = 'dokumen'
    }
    // this.getAgama()
    // this.getPendidikan()
    this.getJob()
    this.getStatus()
    // this.getMasterStructure()
    // this.getMasterIssues()
    await this.getProfile()
    this.getProv()
    await this.getKabupaten(this.prov_id)
    await this.getKecamatan(this.kab_id)
    await this.getKelurahan(this.kec_id)

    if (this.prov_id_domisili) await this.getKabupaten(this.prov_id_domisili, true)
    if (this.kab_id_domisili) await this.getKecamatan(this.kab_id_domisili, true)
    if (this.kec_id_domisili) await this.getKelurahan(this.kec_id_domisili, true)

    try {
      const res = await axios.get('member/member/ktp', {
        headers: {
          'content-type': 'image/png',
          accept: 'image/png'
        },
        responseType: 'blob',
        params: {
          r: Math.floor(Math.random() * (100 - 0 + 1) + 0),
          r2: Math.floor(Math.random() * (10000 - 0 + 1) + 0)
        }
      })
      const urlCreator = window.URL || window.webkitURL
      this.ktpPicHolder = urlCreator.createObjectURL(res.data)
    } catch (err) {
      this.logger(err)
    }
    try {
      const res = await axios.get('member/member/photoprofile', {
        headers: {
          'content-type': 'image/png',
          accept: 'image/png'
        },
        responseType: 'blob',
        params: {
          r: Math.floor(Math.random() * (100 - 0 + 1) + 0),
          r2: Math.floor(Math.random() * (10000 - 0 + 1) + 0)
        }
      })
      const urlCreator = window.URL || window.webkitURL
      this.profilePicHolder = urlCreator.createObjectURL(res.data)
    } catch (err) {
      this.logger(err)
      this.fileNameProfile = ''
    }
    await this.$store.dispatch('getProfile')
    this.profile = this.$store.state.profile
    this.number = this.$cookie.getCookie('number')
  },
  watch: {
    async same_address_domisili () {
      if (this.same_address_domisili) {
        this.kabListDomisili = await this.kabList
        this.kecListDomisili = await this.kecList
        this.kelListDomisili = await this.kelList
        this.prov_id_domisili = this.prov_id
        this.kab_id_domisili = this.kab_id
        this.kec_id_domisili = this.kec_id
        this.kel_id_domisili = this.kel_id
        this.alamat_domisili = this.alamat_ktp
      } else {
        this.kabListDomisili = []
        this.kecListDomisili = []
        this.kelListDomisili = []
        this.prov_id_domisili = ''
        this.kab_id_domisili = ''
        this.kec_id_domisili = ''
        this.kel_id_domisili = ''
        this.rt_domisili = ''
        this.rw_domisili = ''
        this.alamat_domisili = ''
      }
      this.$forceUpdate()
    },
    completedAddress: {
      deep: true,
      handler: async function () {
        if (this.same_address_domisili) {
          this.prov_id_domisili = this.prov_id
          this.kab_id_domisili = this.kab_id
          this.kec_id_domisili = this.kec_id
          this.kel_id_domisili = this.kel_id
          this.rt_domisili = this.rt
          this.rw_domisili = this.rw
          this.alamat_domisili = this.alamat_ktp
        }
      }
    }
  },
  computed: {
    completedAddress () {
      return [this.alamat_ktp, this.prov_id, this.kab_id, this.kec_id, this.kel_id, this.rt, this.rw]
    }
  }
}
</script>
<style lang="scss" scoped>

.image-holder {
  padding: .4rem;
  border: 1px #ccc solid;
  background-color: #c0c0c0;
  max-height: 250px;
  min-height: 250px;
  object-fit: cover;
}

.password-group {
    // margin-bottom: 1rem;
    position: relative;
    input {
        position: relative;
        margin-bottom: 0;
    }
    i {
        position: absolute;
        top: 50%;
        right: 1em;
        transform: translateY(-50%);
    }
}

.overlay-wrap.modal{
    opacity: 0;
    visibility: hidden;
    transition: all .3s linear;
    display: flex;
    align-items: center;

    &.active{
        opacity: 1;
        visibility: visible;

        .popup{
            transform: translate(0);
        }
    }
}
.modal{
    overflow: auto;
}
.close-overlay {
    position: fixed;
    z-index: 998;
    width: 100%;
    height: 100%;
}
.overlay-wrap.modal {
    .popup{
    width: 100%;
    max-width: 600px;
    z-index: 999;
    position: relative;
    margin: 3rem auto;
        padding: 3rem 2rem 2rem 2rem;
        border-radius: 10px;
    background-color: #fff;
    transform: translate(0,-25%);
    transition: transform .3s ease-out;
    @media only screen and (max-width: 600px) {
            width: 90%;
    }

    .body {
            font-size: 14px;

            .ask {
                font-weight: 600;
            }
            .warning {
                color: $red;

                span {
                    font-weight: 600;
                }
            }
        }

        .footer {
            display: flex;
            justify-content: center;
            gap: 10px;

            button {
                border-radius: 5px;
                font-size: 16px;
                font-weight: bold;
                width: 100%;
            }
            .yes {
                padding: 15px 0;
            }
            .no {
                padding: 15px 0;
            }
        }
    }
}

h1 {
    @media only screen and (max-width: 600px) {
        font-size: 16px;
        margin-bottom: 2rem !important;
        margin-top: 2rem;
    }
}

label {
    font-size: 12px;
}

input,
select,
textarea {
    border-color: #d1d1d1;
    border-width: 1px;
    margin-bottom: 1rem;
    padding: 9px;
    border-radius: 2px;

    &::placeholder {
        color: #ccc;
    }

    &:focus {
        outline-color: $blue;
    }
}

select {
    width: 100%;
    padding: 8.5px 9px;
    background-color: #fff;
}

textarea {
    width: 100%;
}

.btn-profil {
    padding: 7px 20px;
    background-color: #cedaff;
    float: right;
}

.two-grid.formWrap {
    width: 80%;

    @media only screen and (max-width: 600px) {
        grid-template-columns: 1fr;
        width: 100%;
    }
}

.flex {
    width: 90%;

    @media only screen and (max-width: 600px) {
        width: 100%;
        display: block;
    }

    .akun,
    .sandi {
        width: 40%;

        @media only screen and (max-width: 600px) {
            width: 100%;
        }
    }

    label {
        font-size: 12px;
    }

    input {
        border-color: $blue;
        border-width: 1px;
        margin-bottom: 1rem;
        padding: 9px;
        border-radius: 2px;

        &::placeholder {
            color: #ccc;
        }
    }

    input[name=name] {
        text-transform: uppercase;
    }

    // button {
    //     padding: 13px 1rem;
    //     background-color: #cedaff;

    //     @media only screen and (max-width: 600px) {
    //         margin: 2rem auto;
    //     }
    // }
}

.switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 23px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $blue;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 28px;
    width: 28px;
    left: -2px;
    bottom: -2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
    box-shadow: 0 0.3px 1.9px 0 rgba(33, 64, 154, 0.16), 0 0.8px 4.3px 0 rgba(33, 64, 154, 0.12), 0 1.5px 7.7px 0 rgba(33, 64, 154, 0.1), 0 2.4px 12.8px 0 rgba(33, 64, 154, 0.09), 0 4px 21.2px 0 rgba(33, 64, 154, 0.07), 0 6.9px 37px 0 rgba(33, 64, 154, 0.06), 0 15px 80px 0 rgba(33, 64, 154, 0.04);
}

input:checked+.slider {
    background-color: #2196F3;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.switch-group {
    .text-bold {
        width: 400px;
    }
}

.minat {
  max-width: 76%;
}
.divider {
  margin-top: 12px;
  margin-bottom: 12px;
  height: 1px;
  background-color: #C0C0C0;
  width: 100%
}
</style>
